// app/admin/InitAxiosClient.jsx
"use client";
import axios from "axios";
import { useEffect } from "react";
import initializeApp from "@/initialize/init";

export default function InitAxiosClient({ token, type }) {
    axios.defaults.baseURL = process.env.NEXT_PUBLIC_API_BASE_URL;
    axios.defaults.withCredentials = true;
    if (token) {
        axios.defaults.headers["Authorization"] = `Bearer ${token}`;
    } else {
        delete axios.defaults.headers.Authorization;
        delete axios.defaults.headers.common?.Authorization;
    }
    useEffect(() => {
        const eject = initializeApp(token, type); // 여기서는 baseURL/headers 세팅하지 않음
        return () => { eject?.(); };
    }, []);

    return null;
}
